import { getZoneVerticesData } from "../../../../Manager/CommonDataManager";
import { toast } from 'react-toastify';

  var zoneDict = {};
  var zoneColorsDict = {};

  export function plotZonesOnMap(map, maps, selectedAffiliate) {
    let zones = getZoneVerticesData().Table;
    for(let s = 0; s < zones.length; s++)
    {
        if(zones[s].iZVATSPID === selectedAffiliate)
        {
            let key = zones[s].vName;
            if(key in zoneDict)
            {
                let zoneLocations = zoneDict[key];
                let zoneColors = zoneColorsDict[key];
                zoneColors = [{"vZoneColor": zones[s].vZoneColor}];
                let tempDict = {"lat": parseFloat(zones[s].vLat), "lng": parseFloat(zones[s].vLong)};
                zoneLocations.push(tempDict);
                zoneDict[key] = zoneLocations;
                zoneColorsDict[key] = zoneColors;
            }
            else
            {
                let zoneLocations = [];
                let zoneColors = [];
                let tempDict = {"lat": parseFloat(zones[s].vLat), "lng": parseFloat(zones[s].vLong)};
                zoneLocations.push(tempDict);
                zoneColors = [{"vZoneColor": zones[s].vZoneColor}];
                zoneDict[key] = zoneLocations;
                zoneColorsDict[key] = zoneColors;
            }
        }

    }

    let polygons = []
    let counter = 0;
    toast.success("Showing zones on the map.");
    for(let i in zoneDict)
    {
        polygons.push(new maps.Polygon({
            paths: zoneDict[i],
            strokeColor: "black",
            strokeOpacity: 0.3,
            strokeWeight: 2,
            fillColor: zoneColorsDict[i][0].vZoneColor,
            fillOpacity: 0.25,
            title: i
        }));
        polygons[counter].setMap(map);
        counter+=1;
    }
    return polygons;
  }
  
  export function clearZonesFromMap(polygons) {
    polygons.forEach(polygon => polygon.setMap(null));
    zoneDict = {};
    zoneColorsDict = {};
    //toast.warning("Hiding zones from the map.");
  }
  